module.exports = __webpack_public_path__ + "static/media/dashboard.27650e62.svg";